import { DECORATIVE_IMAGE_ALT } from "../../constants.ts";
import type { JSX } from "solid-js";
import backdrop from "../../assets/signup/backdrop.webp";

type SignupLayoutProps = {
  children: JSX.Element;
};

const SignupLayout = (props: SignupLayoutProps) => (
  <div class="relative min-h-screen w-screen bg-surface-extra-subtle">
    <div class="flex h-screen w-screen max-w-681 justify-end">
      <div class="h-full grow overflow-hidden">
        <img class="size-full w-full object-cover object-right" src={backdrop} alt={DECORATIVE_IMAGE_ALT} />
      </div>
      <div class="desktop:relative">
        <div class="absolute inset-0 desktop:inset-auto desktop:top-1/2 desktop:-translate-x-45.5 desktop:-translate-y-1/2 desktop:p-0 desktop:pr-25">
          <div class="flex h-screen w-screen flex-col justify-center-safe overflow-y-auto bg-white px-8 pt-16 pb-18 desktop:h-auto desktop:max-h-min desktop:w-124.5 desktop:rounded-lg desktop:border desktop:border-subtle desktop:p-12">
            {props.children}
          </div>
        </div>
      </div>
      <div class="flex-none desktop:w-104" />
    </div>
  </div>
);

export default SignupLayout;
